import { useEffect } from 'react';

interface Milestone {
     mileStoneName: string;
     mileStoneOrder: number;
}

interface UseMilestoneSelectorProps {
     currentMilestones: any[];
     selectedMilestone: string | null;
     onMilestoneSelect: (milestoneName: string) => void;
}

export const useMilestoneSelector = ({
     currentMilestones,
     selectedMilestone,
     onMilestoneSelect,
}: UseMilestoneSelectorProps) => {
     // Get unique milestone names from current milestones and sort by mileStoneOrder
     const uniqueMilestones = currentMilestones.reduce((acc: Array<Milestone>, milestone: any) => {
          const existingMilestone = acc.find((m: any) => m.mileStoneName === milestone.mileStoneName);
          if (!existingMilestone) {
               acc.push({
                    mileStoneName: milestone.mileStoneName,
                    mileStoneOrder: milestone.mileStoneOrder
               });
          }
          return acc;
     }, [] as Array<Milestone>);

     // Sort by mileStoneOrder
     const sortedMilestones = uniqueMilestones.sort((a: any, b: any) => a.mileStoneOrder - b.mileStoneOrder);

     // Set default milestone as the one with the lowest mileStoneOrder (highest priority)
     useEffect(() => {
          if (!selectedMilestone && sortedMilestones.length > 0) {
               const defaultMilestone = sortedMilestones[0]; // First milestone has lowest mileStoneOrder
               onMilestoneSelect(defaultMilestone.mileStoneName);
          }
     }, [selectedMilestone, sortedMilestones, onMilestoneSelect]);

     return {
          sortedMilestones,
     };
}; 